module.exports = __webpack_public_path__ + "assets/img/pz1.990d820e.png";